/* Afsennah - currency-correct thresholds on the cart.

   Product prices go through Liquid's money filter, so they convert on their own.
   A threshold ("free delivery over 100") is a business rule, not a price: money
   formats it without converting it, and Liquid cannot convert at all.

   Round 13, 2026-09-22. Two faults were found by switching country and reading the
   real page, and both were live:

   1. The map's numbers were never converted. A Swedish shopper with 459 kr in the
      cart was told "100 kr - free delivery + free gift - Unlocked" while the real
      threshold is EUR 100, about 1,149 kr. They would have been charged delivery at
      checkout and received no gift.
   2. tier_map is parsed with newline_to_br, which leaves the newline in place, so
      the FIRST country code of every row after the first never matched. GB fell
      through to the shop-currency fallback and was shown GBP 88 where its own
      shipping setting says GBP 65.

   The model: delivery has a per-country threshold in a declared currency, and the
   gift is ONE number in the shop's own currency, because it comes from one app with
   one setting. Anything not already in the shopper's money is converted here. The
   server sets data-t1p when its delivery threshold is already in presentment money,
   or data-t1 when it still has to be converted. data-t2 is always the gift in shop
   currency.

   Round 14: a mark may carry data-fixed, which means the shop advertises that step
   at one headline figure in one currency (here "over $75") and the amount must NOT
   be converted or overwritten. The distance sentence above it stays in the
   shopper's own money, because "you are 5 away" is only useful in what they pay in. */
(function () {
  if (window.afs2Amounts) return;

  function currency() {
    var C = (window.Shopify && window.Shopify.currency) || {};
    var rate = parseFloat(C.rate);
    if (!C.active || !isFinite(rate) || rate <= 0) return null;
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: C.active,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    } catch (e) {
      return null; // currency code Intl does not know - leave the page as rendered
    }
    return { rate: rate, money: function (cents) { return fmt.format(Math.round(cents) / 100); } };
  }

  /* Any element carrying a shop-currency amount gets it converted and reformatted. */
  window.afs2Amounts = function () {
    var nodes = document.querySelectorAll('[data-afs2-amt]');
    if (!nodes.length) return;
    var C = currency();
    if (!C) return;
    Array.prototype.forEach.call(nodes, function (el) {
      var base = parseFloat(el.getAttribute('data-afs2-amt'));
      if (!isFinite(base)) return;
      el.textContent = C.money(base * C.rate);
    });
  };

  window.afs2Ladder = function () {
    var L = document.querySelector('[data-afs2k-ladder][data-live]');
    if (!L) return;
    var C = currency();
    if (!C) return;

    /* Delivery: already in the shopper's money, or still in the shop's. */
    var t1p = L.getAttribute('data-t1p');
    var t1 = (t1p !== null && t1p !== '')
      ? Math.round(parseFloat(t1p))
      : Math.round(parseFloat(L.getAttribute('data-t1')) * C.rate);
    /* The gift is always one shop-currency number. */
    var t2 = Math.round(parseFloat(L.getAttribute('data-t2')) * C.rate);
    var sub = parseFloat(L.getAttribute('data-sub'));
    if (!isFinite(t1) || !isFinite(t2) || !isFinite(sub)) return;

    var l1 = L.getAttribute('data-l1') || '';
    var l2 = L.getAttribute('data-l2') || '';
    var join = L.getAttribute('data-join') || ' + ';
    var unlocked = L.getAttribute('data-unlocked') || '';

    /* Which reward comes first can only be decided once both are in one currency,
       so the server renders the marks in a fixed order and they are sorted here. */
    var shipMark = L.querySelector('[data-role="ship"]');
    var giftMark = L.querySelector('[data-role="gift"]');
    var one = t1 === t2;

    var lo = (t2 < t1) ? t2 : t1;
    var hi = (t2 < t1) ? t1 : t2;
    var loLabel = (t2 < t1) ? l2 : l1;
    var hiLabel = (t2 < t1) ? l1 : l2;

    function paint(mark, amount, label, isOnly) {
      if (!mark) return;
      mark.style.order = (amount === lo) ? 1 : 2;
      /* A mark the shop advertises at a fixed headline figure keeps its own text. */
      if (!mark.hasAttribute('data-fixed')) {
        var b = mark.querySelector('b');
        if (b) b.textContent = C.money(amount);
      }
      var t = mark.querySelector('[data-role-label]');
      if (t) t.textContent = isOnly ? (l1 + join + l2) : label;
      var hit = sub >= amount;
      mark.classList.toggle('is-hit', hit);
      var em = mark.querySelector('em');
      if (hit && !em && unlocked) {
        em = document.createElement('em');
        em.textContent = unlocked;
        mark.appendChild(em);
      } else if (!hit && em) {
        em.parentNode.removeChild(em);
      }
    }

    if (one) {
      paint(shipMark, t1, l1, true);
      if (giftMark) giftMark.style.display = 'none';
      var wrap = L.querySelector('.afs2k-ladder__marks');
      if (wrap) wrap.classList.add('is-one');
    } else {
      paint(shipMark, t1, l1, false);
      paint(giftMark, t2, l2, false);
    }

    var nextAt = 0, nextLabel = '';
    if (sub < lo) { nextAt = lo; nextLabel = one ? (l1 + join + l2) : loLabel; }
    else if (sub < hi) { nextAt = hi; nextLabel = hiLabel; }

    function fill(tpl, amount, label) {
      return (tpl || '').replace('[amount]', C.money(amount)).replace('[reward]', label.toLowerCase());
    }

    var head = L.querySelector('[data-afs2k-ladder-t]');
    if (head) {
      head.innerHTML = nextAt
        ? fill(L.getAttribute('data-away'), nextAt - sub, nextLabel)
        : (L.getAttribute('data-done') || '');
    }

    var bar = L.querySelector('.afs2k-ladder__fill');
    if (bar) bar.style.width = Math.min(100, hi ? (sub / hi * 100) : 0) + '%';

    var sticky = document.querySelector('[data-afs2k-sticky-t]');
    if (sticky) {
      sticky.textContent = nextAt
        ? fill(L.getAttribute('data-sticky-away'), nextAt - sub, nextLabel)
        : (L.getAttribute('data-sticky-done') || '');
    }

    /* Summary rows stay tied to their own threshold, never to lo/hi: delivery is
       t1 and the gift is t2 whatever order they appear in on the ladder. */
    var shipRow = document.querySelector('[data-afs2k-shiprow]');
    if (shipRow && sub >= t1) {
      var free = shipRow.getAttribute('data-free');
      var b2 = shipRow.querySelector('b');
      if (b2 && free) b2.textContent = free;
      shipRow.classList.add('is-free');
    }
    var giftRow = document.querySelector('[data-afs2k-giftrow]');
    if (giftRow && !one && sub >= t2) giftRow.hidden = false;
  };

  function run() { window.afs2Amounts(); window.afs2Ladder(); }
  window.afs2Refresh = run;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();